export const convertStringToPhone = (phoneString: string) => {
  if (phoneString.length !== 11) {
    throw new Error("phoneString is invalid");
  }

  return `+${phoneString[0]} (${phoneString.substring(1, 4)}) ${phoneString.substring(4, 7)}-${phoneString.substring(7, 9)}-${phoneString.substring(9)}`;
};
